module.exports = __webpack_public_path__ + "img/tx-_0000s_0005_6.f45d3dc2.png";